import profileRequest from '@ertelecom/ui-react/components/requests/profileRequest';
import { captureQueryError, TResponse } from '~/src/api/helper';

type Response = TResponse<number, any>;

export async function addUnconfirmedEmail(
    domain: string,
    accessToken: string,
    email: string,
    url?: string,
    showCode?: boolean,
    templateId?: number
): Promise<Response> {
    try {
        const axiosInstance = profileRequest(domain, accessToken);
        const resp = await axiosInstance.post('/contacts/add-unconfirmed-email', {
            email,
            show_code: showCode,
            template_id: templateId,
            url,
        });

        return {
            isSuccess: true,
            payload: resp.data,
        };
    } catch (err) {
        return captureQueryError(err);
    }
}
